interface ExternalResourcesConfig {
  envJsUrl?: string
}

export async function loadExternalResources(config?: ExternalResourcesConfig): Promise<void> {
  if (!config) {
    return
  }

  const tasks: Promise<void>[] = []

  if (config.envJsUrl) {
    tasks.push(loadEnvJs(config.envJsUrl))
  }

  await Promise.all(tasks)
}

function loadEnvJs(url: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = url
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error(`Falha ao carregar o script de ambiente: ${url}`))
    document.head.appendChild(script)
  })
}

